<template>
  <div class="body">
    <div class="content">
      <h1>Login to your Account</h1>
      <TestView :class="{ active: isActive }" />

      <div v-if="isLoading" class="spinner"></div>

      <div v-else>
        <form @submit.prevent="handleAuth">
          <input
            type="email"
            autocomplete="off"
            v-model="email"
            id="email"
            placeholder="E-Mail"
            required
          />
          <input
            type="password"
            v-model="password"
            id="password"
            placeholder="Password"
            required
          />

          <button type="submit">Login</button>
        </form>

        <p v-if="error" class="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import TestView from "./TestView.vue";
export default {
  components: {
    TestView,
  },
  data() {
    return {
      email: "",
      password: "",
      isLoading: false,
      isActive: false,
      error: "",
      hardcodedUser: {
        email: "demo@easyright.com",
        password: "123",
      },
    };
  },
  methods: {
    async handleAuth() {
      this.isLoading = true;
      this.isActive = true;
      this.error = "";

      setTimeout(() => {
        if (
          this.email === this.hardcodedUser.email &&
          this.password === this.hardcodedUser.password
        ) {
          window.location = "/app";
        } else {
          this.error = "Invalid email or password.";
          this.isLoading = false;
          this.isActive = false;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.body {
  background-color: #f5f5f5;
  font-family: Arial, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
}

.active {
  visibility: hidden;
}

h1 {
  font-weight: 300;
}

.content {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 350px;
  text-align: center;
}

form {
  display: flex;
  flex-direction: column;
}

label {
  margin: 10px 0 5px;
  color: #333;
}

input {
  padding: 10px;
  border: 1px solid #ccc;
  background: #fff;
  color: #333;
  border-radius: 5px;
  margin: 10px;
}

button {
  margin-left: 100px;
  margin-right: 100px;
  margin-top: 10px;
  padding: 10px;
  background: #444;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background: #333;
}

.error {
  color: red;
  margin-top: 10px;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #333;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 0.8s linear infinite;
  margin: 20px auto;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
